import { FactoryPreset } from '@ipfabric/utils';
import { is } from '@ipfabric/utils/fp/comparison';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { flow } from 'fp-ts/lib/function';

export const discardTopologyPresetChanges: GraphCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.layoutSettings.presetDraft =
        draft.layoutSettings.presets.find(
          flow(prop('id'), is(draft.layoutSettings.presetDraft.id)),
        ) ?? FactoryPreset;
    });
  };
